const canonicalPublicKey = (op) => String(
  op?.operator_public_key || op?.operator_key || op?.key || ""
).trim().toLowerCase();

export const isApprovedPublicOperator = (op) => (
  Boolean(canonicalPublicKey(op))
  && op?.public_eligible === true
  && op?.public_eligibility_source === "public_operator_directory"
  && op?.public_directory_enabled === true
  && op?.public_filter_enabled === true
);

export function publicCompetitionOperators(operators) {
  const source = Array.isArray(operators) ? operators : [];
  const selected = [];
  const seenKeys = new Set();

  for (const operator of source) {
    if (!isApprovedPublicOperator(operator)) continue;
    const key = canonicalPublicKey(operator);
    if (seenKeys.has(key)) continue;
    seenKeys.add(key);
    selected.push(operator);
  }

  return selected;
}
